<template>
    <MainLayout>
        <LoaderPage v-if="loadingPage" />
        <div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-sticky tw-top-0 tw-z-10">
            <div class="tw-mx-auto tw-px-6 tw-py-4 tw-flex tw-justify-between tw-items-center">
                <div>
                    <h1 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-800'" class="tw-text-2xl tw-font-bold">Configurações da Unidade</h1>
                </div>
                <div class="tw-flex tw-items-center tw-gap-4">
                    <span v-if="!permissaoEditar" :class="theme === 'dark' ? 'tw-bg-amber-500/10 tw-text-amber-400 tw-border-amber-500/20' : 'tw-bg-amber-50 tw-text-amber-700 tw-border-amber-200'" class="tw-px-4 tw-py-1.5 tw-rounded-full tw-border">
                        Modo Visualização
                    </span>
                </div>
            </div>
        </div>
        <main :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-min-h-screen tw-mx-auto tw-p-6">
            <div class="tw-max-w-2xl">
                <section :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-slate-50'" class="tw-rounded-2xl tw-p-4 tw-shadow-sm">
                    <div :class="theme === 'dark' ? 'tw-flex tw-items-center tw-justify-between tw-p-4 tw-bg-[#1a1d21] tw-rounded-xl tw-mb-2' : 'tw-flex tw-items-center tw-justify-between tw-p-4 tw-bg-white tw-rounded-xl tw-mb-2'">
                        <div class="tw-flex tw-items-center tw-gap-4">
                            <div class="tw-p-3 tw-rounded-xl" :class="theme === 'dark' ? 'tw-bg-blue-500/10 tw-text-blue-400' : 'tw-bg-blue-50 tw-text-blue-600'">
                                <svg class="tw-w-8 tw-h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                            </div>
                            <div>
                                <h3 :class="theme === 'dark' ? 'tw-text-slate-200' : 'tw-text-slate-700'" class="tw-font-semibold">Enviar Relatório de Termometria via E-mail</h3>
                                <p :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-500'" class="tw-text-sm tw-mt-1">Ativar o envio automático do relatório de termometria</p>
                            </div>
                    </div>
                        <label class="tw-relative tw-inline-flex tw-items-center tw-cursor-pointer">
                            <input 
                                type="checkbox" 
                                v-model="parametros_configuracoes['envio_email_termometria']" 
                                true-value="1" 
                                false-value="0" 
                                :disabled="!permissaoEditar" 
                                class="tw-sr-only tw-peer"
                            >
                            <div :class="theme === 'dark' ? 'tw-w-12 tw-h-6 tw-bg-slate-700 tw-rounded-full tw-peer peer-checked:tw-bg-blue-500' : 'tw-w-12 tw-h-6 tw-bg-gray-300 tw-rounded-full tw-peer peer-checked:tw-bg-blue-600'" class="after:tw-content-[''] after:tw-absolute after:tw-top-[2px] after:tw-left-[2px] after:tw-bg-white after:tw-border after:tw-rounded-full after:tw-h-5 after:tw-w-5 after:tw-transition-transform peer-checked:after:tw-translate-x-6"></div>
                        </label>
                    </div>
                    <div v-if="permissaoEditar" class="tw-flex tw-gap-3 tw-justify-end tw-mt-8">
                        <button 
                            @click="resetParametros" 
                            :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-300 tw-text-slate-700 hover:tw-bg-gray-400'" 
                            class="tw-px-5 tw-py-2 tw-text-sm tw-font-semibold tw-rounded-xl"
                        >
                            Descartar
                        </button>
                        <button 
                            @click="storeParametrosConfiguracoes"
                            :disabled="saveParametrosLoading"
                            :class="theme === 'dark' ? 'tw-bg-blue-500 hover:tw-bg-blue-600 focus:tw-ring-blue-500/20' : 'tw-bg-blue-600 hover:tw-bg-blue-700 focus:tw-ring-blue-100'"
                            class="tw-px-6 tw-py-2.5 tw-text-white tw-text-sm tw-font-bold tw-rounded-xl tw-shadow-sm focus:tw-ring-4 disabled:tw-opacity-50 tw-transition"
                        >
                            <span v-if="!saveParametrosLoading">Salvar Configuração</span>
                            <span v-else>Processando...</span>
                        </button>
                    </div>
                </section>
            </div>
        </main>
    </MainLayout>
</template>

<script>
import MainLayout from '@/components/layouts/v2/MainLayout.vue';
import LoaderPage from '@/components/ui/v2/LoaderPage.vue';
import { useToast } from 'vue-toastification';
import { mapState } from 'vuex';

export default {
    components: {
        MainLayout,
        LoaderPage
    },

    data() {
        return {
            saveParametrosLoading: false,
            parametros_configuracoes: {
                "envio_email_termometria": null
            },
            loadingPage: true,
            permissaoEditar: false,
            parametrosOriginais: {}
        }
    },

    computed: {
        ...mapState({
            theme: state => state.ui.theme,
        }),
    },

    async mounted() {
        this.toast = useToast();
        this.getParametrosConfiguracoes();
    },

    methods: {
        async getParametrosConfiguracoes() {
            try {
                const response = await this.$store.dispatch('unidade/getConfiguracoes', this.$route.params.unidade);
                await this.$store.dispatch("unidade/fetchUnidade", response.unidade_id || this.$route.params.unidade);
                
                if (response) {
                    this.parametros_configuracoes = {
                        envio_email_termometria: response.data.envio_email_termometria || 0
                    };
                    this.parametrosOriginais = JSON.parse(JSON.stringify(this.parametros_configuracoes));
                    this.permissaoEditar = this.$store.state.unidade.unidade.permissoes.alteracao_configuracoes_unidade !== 0;
                } 
            } catch (error) {
                console.error("Erro ao buscar os dados:", error);
                this.toast.error("Erro ao buscar as configurações");
                this.permissaoEditar = false;
            }
            this.loadingPage = false;
        },

        async storeParametrosConfiguracoes() {
            try{
                this.saveParametrosLoading = true;
                const unidade = this.$route.params.unidade;  
                const datas = JSON.parse(JSON.stringify(this.parametros_configuracoes));
                await this.$store.dispatch('unidade/storeConfiguracoes', {'unidadeId': unidade, 'data': datas });
                
                this.toast.success("Configuração salva com sucesso.");
                this.saveParametrosLoading = false;
                this.parametrosOriginais = JSON.parse(JSON.stringify(this.parametros_configuracoes));
            } catch (error) {
                this.getParametrosConfiguracoes();
                this.saveParametrosLoading = false;
                console.error("Erro ao atualizar configurações:", error);
                this.toast.error("Erro ao atualizar a configuração");
            }
        },

        resetParametros() {
            this.parametros_configuracoes = JSON.parse(JSON.stringify(this.parametrosOriginais));
        }
    }
}
</script>
